import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import chefCooking from '../../images/chef-cooking.jpg';
import food1 from '../../images/food-1.jpg';
import food2 from '../../images/food-2.jpg';
import gallery1 from '../../images/gallery-1.jpg';
import gallery2 from '../../images/gallery-2.jpg';
import { useSlider } from '../../hooks';
import './ImageSlider.css';

interface SlideItem {
  src: string;
  titleKey: string;
}

/**
 * Image slider component with auto-play
 */
const ImageSlider: React.FC = () => {
  const { t } = useTranslation();
  
  const slides: SlideItem[] = useMemo(
    () => [
      { src: chefCooking, titleKey: 'slider.chef' },
      { src: food1, titleKey: 'slider.steak' },
      { src: food2, titleKey: 'slider.shrimp' },
      { src: gallery1, titleKey: 'slider.setup' },
      { src: gallery2, titleKey: 'slider.presentation' },
    ],
    []
  );

  const { currentSlide, nextSlide, prevSlide, goToSlide } = useSlider({
    totalSlides: slides.length,
    autoPlay: true,
    intervalMs: 2500,
  });

  return (
    <section className="slider-section">
      <div className="slider">
        <div className="slide-container">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`slide ${index === currentSlide ? 'active' : ''}`}
              style={{ backgroundImage: `url(${slide.src})` }}
            >
              <div className="slide-content">
                <h2>{t(slide.titleKey)}</h2>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation buttons */}
        <button
          className="slider-btn prev"
          onClick={prevSlide}
          aria-label="Previous slide"
          type="button"
        >
          ❮
        </button>
        <button
          className="slider-btn next"
          onClick={nextSlide}
          aria-label="Next slide"
          type="button"
        >
          ❯
        </button>

        {/* Slide indicators */}
        <div className="slide-indicators" role="tablist" aria-label="Slider navigation">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              role="tab"
              aria-selected={index === currentSlide}
              aria-label={`Go to slide ${index + 1}`}
              type="button"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageSlider;


